import React from "react";
import {
  CreateButton,
  Datagrid,
  EditButton,
  FunctionField,
  List,
  ListActions,
  ReferenceField,
  ShowButton,
  SimpleList,
  TextField,
  Title,
  useStore,
} from "react-admin";
import CustomFilter from "features/CustomFilter";
import useInternshipFilter from "features/filters/useInternshipFilter";
import { Box, Paper, Typography, useMediaQuery } from "@mui/material";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { checkPermission } from "server/security/utils";
import { getPermissions } from "auth/security/securityUtils";
import { administrationRequests } from "api/administrationApi";
import RoomField from "server/components/Fields/RoomField";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import { MOBILE_BREAKPOINT } from "utils/constants";

const STORE_KEY = "internshipFreeSelectionSchedule.filters";

const ListScheduleFreeSelectionSlot = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const [filters, setFilters] = useStore(STORE_KEY, null);
  const internship = useInternshipFilter({ filters, withPlan: true });

  const handleSearch = selectedFilters => {
    setFilters(selectedFilters);
  };

  return (
    <>
      {!filters && <Title title={"Свободен избор разписания"} />}
      <CustomFilter
        title="Избери филтри"
        cardWidth={isMobile ? "100%" : "700px"}
        filters={internship.fields}
        buttonLabel="Покажи"
        buttonDisabled={!internship.isComplete}
        buttonOnClick={() => handleSearch(internship.query)}
      />
      {!filters ? (
        <Paper sx={{ mt: 5 }}>
          <Box
            p={2}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography
              align="center"
              color="secondary"
            >
              Въведи филтри за свободен избор разписание или създай ново
            </Typography>
            <SecuredComponent permission={permissions.canManageInternshipSchedules}>
              <CreateButton />
            </SecuredComponent>
          </Box>
        </Paper>
      ) : (
        <List
          exporter={false}
          title="Свободен избор разписания"
          filter={filters}
          actions={
            <ListActions hasCreate={checkPermission(getPermissions(), permissions.canManageInternshipSchedules)} />
          }
        >
          {isMobile ? (
            <SimpleList
              linkType={false}
              sx={settings.style.mobileList}
              primaryText={record => (
                <MobileListRow
                  fields={[
                    {
                      label: "Дисциплина",
                      value: (
                        <ReferenceField
                          source="disciplineId"
                          reference={administrationRequests.getDisciplinesSelect()}
                        >
                          <TextField source="name" />
                        </ReferenceField>
                      ),
                    },
                  ]}
                />
              )}
              secondaryText={record => (
                <div>
                  <MobileListRow fields={[{ label: "Зала", value: <RoomField /> }]} />
                  <MobileListRow fields={[{ label: "Капацитет", value: record?.studentsCapacity }]} />
                  <MobileListRow
                    fields={[{ label: "Час", value: `${record?.fromTime} - ${record?.toTime}` }]}
                  />
                </div>
              )}
              tertiaryText={() => (
                <>
                  <SecuredComponent permission={permissions.canPreviewInternshipSchedules}>
                    <ShowButton label="" />
                  </SecuredComponent>
                  <SecuredComponent permission={permissions.canManageInternshipSchedules}>
                    <EditButton label="" />
                  </SecuredComponent>
                </>
              )}
            />
          ) : (
            <Datagrid
              bulkActionButtons={false}
              rowClick={false}
            >
              <ReferenceField
                source="disciplineId"
                reference={administrationRequests.getDisciplinesSelect()}
                label="Дисциплина"
                sortable={false}
              >
                <TextField source="name" />
              </ReferenceField>
              <RoomField label="Зала" />
              <TextField
                source="studentsCapacity"
                label="Капацитет"
                sortable={false}
              />
              <FunctionField
                label="Час"
                render={rec => `${rec.fromTime} - ${rec.toTime}`}
              />
              <SecuredComponent permission={permissions.canPreviewInternshipSchedules}>
                <ShowButton />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canManageInternshipSchedules}>
                <EditButton />
              </SecuredComponent>
            </Datagrid>
          )}
        </List>
      )}
    </>
  );
};

export default ListScheduleFreeSelectionSlot;
